import ErrorManager from '@/common/utils/ErrorManager';
import RequestInterventionWidgetItems from '@/models/RequestInterventionWidgetItems';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import HomeService from '@/modules/Home/services/HomeService';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit, MutationTree } from 'vuex';
import { INTERVENTION_REQUEST_WIDGET } from '../mutation-types';
import { FiltreStats } from '@/models/FiltreStats';

export interface InterventionRequestState {
    interventionRequestItems: RequestInterventionWidgetItems;
    isLoading: boolean;
    error: boolean;
}

const initialState = (): InterventionRequestState => ({
    interventionRequestItems: {
        nbPlanifie: 0,
        nbNonPlanifie: 0,
        nbEnCours: 0,
        nbTraite: 0,
    },
    isLoading: false,
    error: false,
});

export enum InterventionRequestAction {
    GET_INTERVENTION_REQUEST_DATA = 'GET_INTERVENTION_REQUEST_DATA',
}

interface InterventionRequestActionType {
    commit: Commit;
    state: InterventionRequestState;
}

const actions: ActionTree<InterventionRequestState, RootState> = {
    async [InterventionRequestAction.GET_INTERVENTION_REQUEST_DATA]({
                                                                        commit, state
                                                                    }: InterventionRequestActionType, siteIds: number[]): Promise<RequestInterventionWidgetItems | null> {
        commit(INTERVENTION_REQUEST_WIDGET.SET_LOADING, true);
        const filtre: FiltreStats = {siteIds : siteIds};
        let requestInterventionData: RequestInterventionWidgetItems | null = null;
        await HomeService.getInterventionRequestData(filtre)
            .then(async response => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(INTERVENTION_REQUEST_WIDGET.SET_ERROR, true);
                        commit(INTERVENTION_REQUEST_WIDGET.SET_LOADING, false);
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                            { root: true }
                        );
                    }
                    requestInterventionData = response.data;
                    commit(INTERVENTION_REQUEST_WIDGET.SET_ITEMS, requestInterventionData);
                    commit(INTERVENTION_REQUEST_WIDGET.SET_LOADING, false);
                    return requestInterventionData;
                } else {
                    commit(INTERVENTION_REQUEST_WIDGET.SET_ERROR, true);
                    commit(INTERVENTION_REQUEST_WIDGET.SET_LOADING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                        { root: true }
                    );
                    return null;
                }
            })
            .catch(async error => {
                commit(INTERVENTION_REQUEST_WIDGET.SET_ERROR, true);
                commit(INTERVENTION_REQUEST_WIDGET.SET_LOADING, false);
                commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
            });
        return requestInterventionData;
    },
};

const mutations: MutationTree<InterventionRequestState> = {
    [INTERVENTION_REQUEST_WIDGET.SET_LOADING](state: InterventionRequestState, isLoading: boolean): void {
        state.isLoading = isLoading;
    },
    [INTERVENTION_REQUEST_WIDGET.SET_ERROR](state: InterventionRequestState, error: boolean): void {
        state.error = error;
    },
    [INTERVENTION_REQUEST_WIDGET.SET_ITEMS](
        state: InterventionRequestState,
        items: RequestInterventionWidgetItems
    ): void {
        state.interventionRequestItems = items;
    },
    [INTERVENTION_REQUEST_WIDGET.RESET](
        state: InterventionRequestState,
    ): void {
        Object.assign(state, initialState());
    },
};

const widgetDemandeIntervention = {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
};

export default widgetDemandeIntervention;
